<template>
  <div class="top">
    <div class="top__title-wrap">
      <div class="top__header">
        <img class="top__header-logo" src="../../static/header_logo.svg" alt="ティップネスキッズロゴ">
        <p class="top__header-title">ティップネス・キッズ</p>
      </div>
      <div class="top__title-text-wrap">
        <p class="top__sub-title">お子さまの状態を確認！</p>
        <p class="top__title">『負けないカラダ診断』</p>
      </div>
    </div>
    <div class="top__container">
      <div class="top__contents-wrap">
        <div class="top__main-text">
          <p class="top__text-head">お子さまの<br>運動習慣が気になる<br>保護者様必見！</p>
          <p class="top__text-body">
            お子さまの現在の<br>
            <span class="top__text-body--green">生活習慣力</span>・<span class="top__text-body--orange">運動習慣力</span><br>
            <span class="top__text-body--blue">カラダコントロール力</span><br>
            をチェックしてみませんか？
          </p>
          <p class="top__text-bottom">
            6つの質問に答えるだけ。<br>
            負けないカラダを<br>
            育てるためのヒントが<br>
            隠されているかも？
          </p>
        </div>
        <p class="top__sub-text">
          ボタンを押して診断開始。簡単な6つの設問に回答いただくと、「お子さまへの特別なアドバイス」をお届けします。ぜひお試しください。
        </p>
      </div>
      <button class="top__start-button">
        <router-link to="/question"><p class="top__start-button-link">診断をはじめる</p></router-link>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  max-width: 375px;
  margin: -32px auto 0;
  background-image: url(../top_bg.png);
  background-size: contain;
  background-position: top;
}

.top__container {
  padding: 0 16px;
}

.top__header{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 45px;
}

.top__header-logo{
  width: 42px;
  height: 42px;
}

.top__header-title{
  display: inline-block;
  margin-left: 9px;
  font-size: 22px;
  color: #1E2D73;
  letter-spacing: -2px;
}

.top__title-wrap {
  margin-bottom: 25px;
  max-width: 375px;
  width: 100%;
  height: 301px;
  background: url("../top_title_bg.png") top center no-repeat;
}

.top__title-text-wrap {
  width: 100%;
  padding: 74px 0;
  font-weight: 900;
  letter-spacing: 2px;
  background-size: contain;
  border-radius: 10px;
}

.top__sub-title {
  display: inline-block;
  margin-bottom: 12px;
  font-size: 19px;
  line-height: 24px;
  text-shadow:
      #fff 2px 0px,  #fff -2px 0px,
      #fff 0px -2px, #fff 0px 2px,
      #fff 2px 2px , #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px,
      #fff 2px 2px,  #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px,
      #fff 2px 2px,  #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px;
}

.top__title {
  font-size: 29px;
  line-height: 33px;
  letter-spacing: 1px;
  text-shadow:
      #fff 2px 0px,  #fff -2px 0px,
      #fff 0px -2px, #fff 0px 2px,
      #fff 2px 2px , #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px,
      #fff 2px 2px,  #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px,
      #fff 2px 2px,  #fff -2px 2px,
      #fff 2px -2px, #fff -2px -2px;
}

@media screen and (max-width: 367px) {
  .top__title {
    font-size: 25px;
  }

  .top__sub-title {
    font-size: 18px;
  }
}

.top__contents-wrap {
  max-width: 375px;
  margin-bottom: 48px;
  padding: 32px 16px 32px;
  background-color: #fff;
  border-radius: 10px;
  color: #1B1C3B;
}

.top__main-text {
  font-size: 22px;
  line-height: 37px;
}

.top__text-head {
  text-align: center;
  margin-bottom: 17px;
}

.top__text-body {
  margin-bottom: 37px;
}

.top__text-body--green {
  color: #48A035;
}

.top__text-body--orange {
  color:#F7772F;
}

.top__text-body--blue {
  color: #018CD7;
}

.top__text-bottom {
  margin-bottom: 11px;
}

.top__sub-text {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
}

@media screen and (max-width: 367px) {
  .top__text-head {
    font-size: 19px;
  }

  .top__text-body {
    font-size: 19px;
  }

  .top__text-bottom {
    font-size: 19px;
  }

  .top__sub-text {
    font-size: 13px;
  }
}

.top__start-button {
  position: relative;
  width: 100%;
  margin-bottom: 50px;
  background: #fff;
  border: 3px solid #F7772F;
  border-radius: 32px;
  color: #F7772F;
  box-shadow: 0 2px rgba(93, 93, 93, 0.3);
  z-index: 3;
}

.top__start-button::after {
  position: absolute;
  display: block;
  content: "";
  width: 17px;
  height: 17px;
  background: url(../top_button_arrow.svg) top center no-repeat;
  top: 50%;
  transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  right: 20px;
  z-index: 2;
}

.top__start-button-link {
  position: relative;
  display: inline-block;
  text-decoration: none;
  width: 100%;
  padding: 18px 0;
  font-size: 19px;
  font-weight: 800;
  font-family: vdl-v7marugothic, Helvetica, Arial, sans-serif;
  line-height: 1;
  color: #FF9600;
}
</style>



// WEBPACK FOOTER //
// src/components/TopPage.vue